import { Component, forwardRef, KeyValueDiffers, Inject, OnChanges, OnInit, ElementRef, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';

import { LocalizationService } from '../../../../Core/Localization/services/localization.service';
import { CurrentUserStateService } from '../../../../Core/Users/services/current-user-state.service';
import { MonitorConfigService } from '../../../MonitorShared/services/monitor-config.service';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';

import { BlockComponent } from '../../../PageBuilder/components/Block/block.component';
import { AbstractPageBuilderService } from '../../../PageBuilder/services/abstract-page-builder.service';
import { CoverageSummaryChartBlockComponent } from '../../../Reports/components/CoverageSummaryChartBlock/coverage-summary-chart-block.component';
import { ReportsSeriesPreviewService } from '../../../Reports/services/report-series-preview.service';
import { ReportsChartOptionsService } from '../../../Reports/services/reports-chart-options.service';
import { ConfirmDialogComponent } from '../../../Dialogs/components/ConfirmDialog/confirm-dialog.component';
import { ConfirmDialogModel } from '../../../Dialogs/models/confirm-dialog.model';
import { messageSeverityEnum } from '../../../Misc/enums/message-severity.enum';
import { UserPreferencesService } from '../../../../Account/UserPreferences/services/user-preferences.service';
import { ClickOutsideService } from '../../../../Common/PageBuilder/services/click-outside.service';
import { ReportsChartDetailService } from '../../../Reports/services/reports-chart-detail.service';
import { SocialChartDetailsDialogService } from '../../../../Social/Intelligence/services/social-chart-details-dialog.service';
import { ConfigService } from '../../../../Core/Config/services/config.service';
import { ChartSizeHelper } from '@Common/Charts/helpers/chart-size.helper';
import { DataConnectionService } from '../../../../Core/Users/services/data-connection.service';
import { ReportsChartSeriesConverterService } from '../../../Reports/services/reports-chart-series-converter.service';
import { ReportsSeriesPreviewNewService } from '../../../../Common/Reports/services/reports-series-preview-new.service';

@Component({
    selector: 'agpr-dashboard-coverage-summary-chart-block',
    templateUrl: './dashboard-coverage-summary-chart-block.component.html',
    styleUrls: ['./dashboard-coverage-summary-chart-block.component.scss'],
    providers: [
        {
            provide: BlockComponent,
            useExisting: forwardRef(() => DashboardCoverageSummaryChartBlockComponent)
        }
    ],
    standalone: false
})
export class DashboardCoverageSummaryChartBlockComponent extends CoverageSummaryChartBlockComponent implements OnChanges, OnInit, OnDestroy {

    numOfDataItems: number = 3;

    constructor(
        public differs: KeyValueDiffers,
        public pageBuilderService: AbstractPageBuilderService,
        public reportSeriesPreviewService: ReportsSeriesPreviewService,
        public reportsChartOptionsService: ReportsChartOptionsService,
        public elementRef: ElementRef,
        public localizationService: LocalizationService,
        @Inject(APP_BASE_HREF) public appBaseHref: string,
        public changeDetectorRef: ChangeDetectorRef,
        public userStateService: CurrentUserStateService,
        public monitorConfigService: MonitorConfigService,
        public coreDialogService: CoreDialogService,
        protected userPreferencesService: UserPreferencesService,
        public clickOutsideService: ClickOutsideService,
        public reportsChartDetailService: ReportsChartDetailService,
        public socialChartDetailsDialogService: SocialChartDetailsDialogService,
        public configService: ConfigService,
        public dataConnectionService: DataConnectionService,
        public reportsChartSeriesConverterService: ReportsChartSeriesConverterService,
        public reportsSeriesPreviewNewService: ReportsSeriesPreviewNewService
    ) {
        super(
            differs,
            pageBuilderService,
            reportSeriesPreviewService,
            reportsChartOptionsService,
            elementRef,
            localizationService,
            appBaseHref,
            changeDetectorRef,
            userStateService,
            monitorConfigService,
            userPreferencesService,
            clickOutsideService,
            reportsChartDetailService,
            socialChartDetailsDialogService,
            configService,
            dataConnectionService,
            reportsChartSeriesConverterService,
            reportsSeriesPreviewNewService
        );
    }

    ngOnChanges(): void {
        super.ngOnChanges();
        this.numOfDataItems = this.displayElement?.metrics?.length;

        if (!this.numOfDataItems) {
            this.numOfDataItems = 3;
        }
    }

    doAction($event: MouseEvent | TouchEvent, action: string): void {
        // we only want the left mouse click
        if ($event.which === 1) {
            if (action === 'delete') {
                this.deleteChart(action);
            } else {
                this.onAction(action);
            }
        }
    }

    deleteChart(action: string) {
        const confirmConfig: ConfirmDialogModel = {
            inputs: {
                id: 'dashboard.deleteChartConfirmDialog',
                heading: this.localizationService.transform('Dashboard.confirmDialog.deleteChart.heading'),
                message: this.localizationService.transform('Dashboard.confirmDialog.deleteChart.message'),
                alertType: messageSeverityEnum.warning,
                okLabel: this.localizationService.transform('Dashboard.confirmDialog.deleteChart.button')
            },
            outputs: {
                dialogClose: (confirmed: boolean) => {
                    if (confirmed) {
                        this.onAction(action);
                    }
                }
            }
        };
        this.coreDialogService.open(ConfirmDialogComponent, confirmConfig);
    }
}
